"use strict";
// Vesta is the loan origination system (LOS) provider for mortgage, providing us functionality
// out of the box that specifically helps us meet strict mortgage requirements.
//
// Version 26.2
// Express dates as YYYY-MM-DD
// https://aven.vesta.com/api?version=_26_2
// https://aven.beta.vesta.com/api?version=_26_2
Object.defineProperty(exports, "__esModule", { value: true });
exports.VestaQuoteStatus = exports.VestaLoanAmortizationType = exports.VestaEconsentStatus = exports.VestaEconsentCaptureMethod = exports.VestaLiabilityAccountStatus = exports.VestaLiabilityIntent = exports.VestaLiabilitySubtype = exports.VestaLiabilityType = exports.VestaEmployerStatus = exports.VestaIncomeAmountType = exports.VestaIncomeType = exports.VestaAssetType = exports.VestaHmdaRaceDesignationTypePacificIslander = exports.VestaHmdaRaceDesignationType = exports.VestaHmdaRaceType = exports.VestaHmdaGenderType = exports.VestaHmdaEthnicityType = exports.VestaHmdaEthnicityOriginType = exports.VestaBankruptcyClosedType = exports.VestaBankruptcyChapterType = exports.VestaPriorPropertyTitleType = exports.VestaPriorPropertyUsageType = exports.VestaCitizenshipType = exports.VestaApplicationSubmitMethod = exports.VestaIncomeVerificationConsentType = exports.VestaCreditPullConsentType = exports.VestaMaritalStatus = exports.VestaPhoneNumberType = exports.VestaForm4506CTranscriptType = exports.VestaTaxReturnDocumentCode = exports.VestaTaxTranscriptSigningType = exports.VestaTaxIdentifierType = exports.VestaCreditModelType = exports.VestaCreditScoreBureau = exports.VestaAddressStatus = exports.VestaAddressOccupancyType = exports.VestaPropertyValuationMethodType = exports.VestaPropertyUsageType = exports.VestaPropertyIntendedDisposition = exports.VestaPropertyType = exports.VestaMortgageType = exports.VestaLienType = exports.VestaRefinanceCashOutDeterminationType = exports.VestaLoanType = exports.VestaLoanPurpose = exports.VestaSelectedCreditScoreModel = exports.VestaLoanChannelType = exports.VestaEntityType = exports.VestaLoanStageType = exports.VestaAction = void 0;
exports.VestaDocumentStatus = exports.VestaObjectiveTemplateExternalIdentifier = exports.VestaObjectiveStatus = exports.VestaObjectiveTaskTemplateExternalIdentifier = exports.VestaObjectiveTaskConditionStatus = exports.VestaObjectiveTaskTemplateType = exports.VestaObjectiveTaskStatus = exports.VestaClosingAdjustmentCounterParty = exports.VestaFeeType = exports.VestaFeeCategory = exports.VestaClosingAdjustmentPaidToOrFromBorrower = exports.VestaClosingAdjustmentType = exports.VestaDisclosureRecipientType = exports.VestaDisclosureStatus = exports.VestaDisclosureProvider = exports.VestaDisclosurePackageType = exports.VestaCreditExternalProviderType = exports.VestaCreditPullRequestType = exports.VestaCreditPullType = exports.VestaCreditPullActionType = exports.VestaCompensationPaidByType = exports.VestaQuotePricingScenariosQueryType = exports.VestaMortgageSizeType = void 0;
var VestaAction;
(function (VestaAction) {
    VestaAction["Add"] = "Add";
    VestaAction["Remove"] = "Remove";
})(VestaAction || (exports.VestaAction = VestaAction = {}));
// Taken from our Vesta system. Keep in sync with configuration on Vesta.
// Notably, this is our custom defined enum, different from the LoanStage schema on Vesta.
// @TranslateToPython
var VestaLoanStageType;
(function (VestaLoanStageType) {
    VestaLoanStageType["Prospect"] = "Prospect";
    VestaLoanStageType["Application"] = "Application";
    VestaLoanStageType["Processing"] = "Processing";
    VestaLoanStageType["InitialUnderwriting"] = "Initial Underwriting";
    VestaLoanStageType["PreApprovalUnderwritingReviewReady"] = "PreApproval - Underwriting Review Ready";
    VestaLoanStageType["SubmittedToInvestor"] = "Submitted To Investor";
    VestaLoanStageType["ConditionallyApproved"] = "Conditionally Approved";
    VestaLoanStageType["ClearedToClose"] = "Cleared to Close";
    VestaLoanStageType["Closing"] = "Closing";
    VestaLoanStageType["ReadyToFund"] = "Ready to Fund";
    VestaLoanStageType["ClosingDocsOutSigning"] = "Closing Docs out- Signing";
    VestaLoanStageType["Funded"] = "Funded";
    VestaLoanStageType["Purchased"] = "Purchased";
    VestaLoanStageType["WithdrawnBorrowerRequested"] = "Withdrawn - Borrower Requested";
    VestaLoanStageType["WithdrawnNoActivity"] = "Withdrawn  - No Activity";
    VestaLoanStageType["Withdrawn"] = "Withdrawn";
    /** @deprecated */
    VestaLoanStageType["_WithdrawnNoActivityLegacy"] = "Withdrawn - No Activity";
    VestaLoanStageType["_WithdrawnBorrowerRequest"] = "Withdrawn - Borrower request";
    VestaLoanStageType["Incomplete"] = "Incomplete";
    VestaLoanStageType["Duplicate"] = "Duplicate";
    VestaLoanStageType["Suspended"] = "Suspended";
    VestaLoanStageType["Denied"] = "Denied";
})(VestaLoanStageType || (exports.VestaLoanStageType = VestaLoanStageType = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/OntologyEntityType
var VestaEntityType;
(function (VestaEntityType) {
    VestaEntityType["Loan"] = "Loan";
    VestaEntityType["Borrower"] = "Borrower";
    VestaEntityType["Property"] = "Property";
    VestaEntityType["Asset"] = "Asset";
    VestaEntityType["Income"] = "Income";
    VestaEntityType["Liability"] = "Liability";
    VestaEntityType["BorrowerBusiness"] = "BorrowerBusiness";
    VestaEntityType["ConcurrentFinancing"] = "ConcurrentFinancing";
    VestaEntityType["Proration"] = "Proration";
    VestaEntityType["ClosingCost"] = "ClosingCost";
    VestaEntityType["CreditInquiry"] = "CreditInquiry";
    VestaEntityType["PublicRecord"] = "PublicRecord";
    VestaEntityType["UnderwritingException"] = "UnderwritingException";
    VestaEntityType["PropertyValuation"] = "PropertyValuation";
    VestaEntityType["Document"] = "Document";
    VestaEntityType["PricingRequest"] = "PricingRequest";
    VestaEntityType["TaxTranscriptRequestForm"] = "TaxTranscriptRequestForm";
    VestaEntityType["CollateralException"] = "CollateralException";
    VestaEntityType["ClosingAdjustment"] = "ClosingAdjustment";
})(VestaEntityType || (exports.VestaEntityType = VestaEntityType = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/LoanChannelType
var VestaLoanChannelType;
(function (VestaLoanChannelType) {
    VestaLoanChannelType["Retail"] = "Retail";
    VestaLoanChannelType["Broker"] = "Broker";
})(VestaLoanChannelType || (exports.VestaLoanChannelType = VestaLoanChannelType = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/SelectedCreditScoreModel
var VestaSelectedCreditScoreModel;
(function (VestaSelectedCreditScoreModel) {
    VestaSelectedCreditScoreModel["ClassicFICO"] = "ClassicFICO";
    VestaSelectedCreditScoreModel["VantageScore40"] = "VantageScore40";
})(VestaSelectedCreditScoreModel || (exports.VestaSelectedCreditScoreModel = VestaSelectedCreditScoreModel = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/LoanPurpose
// @TranslateToPython
var VestaLoanPurpose;
(function (VestaLoanPurpose) {
    VestaLoanPurpose["Purchase"] = "Purchase";
    VestaLoanPurpose["Refinance"] = "Refinance";
})(VestaLoanPurpose || (exports.VestaLoanPurpose = VestaLoanPurpose = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/LoanType
var VestaLoanType;
(function (VestaLoanType) {
    VestaLoanType["Mortgage"] = "Mortgage";
    VestaLoanType["HELOC"] = "HELOC";
    VestaLoanType["HomeEquityLoan"] = "HomeEquityLoan";
})(VestaLoanType || (exports.VestaLoanType = VestaLoanType = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/RefinanceCashOutDeterminationType
var VestaRefinanceCashOutDeterminationType;
(function (VestaRefinanceCashOutDeterminationType) {
    VestaRefinanceCashOutDeterminationType["CashOut"] = "CashOut";
    VestaRefinanceCashOutDeterminationType["NoOrLimitedCashOut"] = "NoOrLimitedCashOut";
})(VestaRefinanceCashOutDeterminationType || (exports.VestaRefinanceCashOutDeterminationType = VestaRefinanceCashOutDeterminationType = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/LienPriorityType
var VestaLienType;
(function (VestaLienType) {
    VestaLienType["FirstLien"] = "FirstLien";
    VestaLienType["SecondLien"] = "SecondLien";
    VestaLienType["ThirdLien"] = "ThirdLien";
    VestaLienType["FourthLien"] = "FourthLien";
})(VestaLienType || (exports.VestaLienType = VestaLienType = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/MortgageType
var VestaMortgageType;
(function (VestaMortgageType) {
    VestaMortgageType["Conventional"] = "Conventional";
    VestaMortgageType["FHA"] = "FHA";
    VestaMortgageType["USDA"] = "USDA";
    VestaMortgageType["VA"] = "VA";
})(VestaMortgageType || (exports.VestaMortgageType = VestaMortgageType = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/PropertyType
// @TranslateToPython
var VestaPropertyType;
(function (VestaPropertyType) {
    VestaPropertyType["SingleFamily"] = "SingleFamily";
    VestaPropertyType["Condominium"] = "Condominium";
    VestaPropertyType["Cooperative"] = "Cooperative";
    VestaPropertyType["TwoToFourUnitProperty"] = "TwoToFourUnitProperty";
    VestaPropertyType["ManufacturedHome"] = "ManufacturedHome";
    VestaPropertyType["PlannedUnitDevelopment"] = "PlannedUnitDevelopment";
    VestaPropertyType["Land"] = "Land";
    VestaPropertyType["MultiFamily"] = "MultiFamily";
})(VestaPropertyType || (exports.VestaPropertyType = VestaPropertyType = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/PropertyDisposition
var VestaPropertyIntendedDisposition;
(function (VestaPropertyIntendedDisposition) {
    VestaPropertyIntendedDisposition["Retain"] = "Retain";
    VestaPropertyIntendedDisposition["PendingSale"] = "PendingSale";
    VestaPropertyIntendedDisposition["Sold"] = "Sold";
})(VestaPropertyIntendedDisposition || (exports.VestaPropertyIntendedDisposition = VestaPropertyIntendedDisposition = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/PropertyUsageType
// @TranslateToPython
var VestaPropertyUsageType;
(function (VestaPropertyUsageType) {
    VestaPropertyUsageType["PrimaryResidence"] = "PrimaryResidence";
    VestaPropertyUsageType["SecondHome"] = "SecondHome";
    VestaPropertyUsageType["Investment"] = "Investment";
    VestaPropertyUsageType["Other"] = "Other";
})(VestaPropertyUsageType || (exports.VestaPropertyUsageType = VestaPropertyUsageType = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/ValuationMethod
var VestaPropertyValuationMethodType;
(function (VestaPropertyValuationMethodType) {
    VestaPropertyValuationMethodType["FullAppraisal"] = "FullAppraisal";
    VestaPropertyValuationMethodType["PriorAppraisalUsed"] = "PriorAppraisalUsed";
    VestaPropertyValuationMethodType["DesktopAppraisal"] = "DesktopAppraisal";
    VestaPropertyValuationMethodType["AutomatedValuationModel"] = "AutomatedValuationModel";
    VestaPropertyValuationMethodType["BrokerPriceOpinion"] = "BrokerPriceOpinion";
    VestaPropertyValuationMethodType["DriveBy"] = "DriveBy";
    VestaPropertyValuationMethodType["TaxValuation"] = "TaxValuation";
    VestaPropertyValuationMethodType["Other"] = "Other";
    VestaPropertyValuationMethodType["None"] = "None";
    VestaPropertyValuationMethodType["DeskReview"] = "DeskReview";
    VestaPropertyValuationMethodType["FieldReview"] = "FieldReview";
    VestaPropertyValuationMethodType["HybridAppraisal"] = "HybridAppraisal";
})(VestaPropertyValuationMethodType || (exports.VestaPropertyValuationMethodType = VestaPropertyValuationMethodType = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/OccupancyType
var VestaAddressOccupancyType;
(function (VestaAddressOccupancyType) {
    VestaAddressOccupancyType["Own"] = "Own";
    VestaAddressOccupancyType["Rent"] = "Rent";
    VestaAddressOccupancyType["NoPrimaryHousingExpense"] = "NoPrimaryHousingExpense";
})(VestaAddressOccupancyType || (exports.VestaAddressOccupancyType = VestaAddressOccupancyType = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/AddressStatus
var VestaAddressStatus;
(function (VestaAddressStatus) {
    VestaAddressStatus["Current"] = "Current";
    VestaAddressStatus["Previous"] = "Previous";
})(VestaAddressStatus || (exports.VestaAddressStatus = VestaAddressStatus = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/CreditBureau
var VestaCreditScoreBureau;
(function (VestaCreditScoreBureau) {
    VestaCreditScoreBureau["Equifax"] = "Equifax";
    VestaCreditScoreBureau["Experian"] = "Experian";
    VestaCreditScoreBureau["TransUnion"] = "TransUnion";
    VestaCreditScoreBureau["Other"] = "Other";
})(VestaCreditScoreBureau || (exports.VestaCreditScoreBureau = VestaCreditScoreBureau = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/CreditModelType
// NOTE: Vesta's API docs misspell "Isaac" as "Issac" — we match their spelling intentionally.
var VestaCreditModelType;
(function (VestaCreditModelType) {
    VestaCreditModelType["EquifaxBeacon5"] = "EquifaxBeacon5";
    VestaCreditModelType["ExperianFairIssacRiskModelV2"] = "ExperianFairIssacRiskModelV2";
    VestaCreditModelType["TransUnionFicoRiskScoreClassic04"] = "TransUnionFicoRiskScoreClassic04";
    VestaCreditModelType["TransUnionFicoRiskScoreClassic98"] = "TransUnionFicoRiskScoreClassic98";
    VestaCreditModelType["VantageScore20"] = "VantageScore20";
    VestaCreditModelType["VantageScore30"] = "VantageScore30";
    VestaCreditModelType["VantageScore40"] = "VantageScore40";
    VestaCreditModelType["EquifaxVantageScore40"] = "EquifaxVantageScore40";
    VestaCreditModelType["ExperianVantageScore40"] = "ExperianVantageScore40";
    VestaCreditModelType["TransUnionVantageScore40"] = "TransUnionVantageScore40";
})(VestaCreditModelType || (exports.VestaCreditModelType = VestaCreditModelType = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/TaxIdentifierType
var VestaTaxIdentifierType;
(function (VestaTaxIdentifierType) {
    VestaTaxIdentifierType["SocialSecurityNumber"] = "SocialSecurityNumber";
    VestaTaxIdentifierType["IndividualTaxpayerIdentificationNumber"] = "IndividualTaxpayerIdentificationNumber";
    // Vesta does not support EmployerIdentificationNumber
})(VestaTaxIdentifierType || (exports.VestaTaxIdentifierType = VestaTaxIdentifierType = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/TaxTranscriptSigningType
var VestaTaxTranscriptSigningType;
(function (VestaTaxTranscriptSigningType) {
    VestaTaxTranscriptSigningType["WetSigned"] = "WetSigned";
    VestaTaxTranscriptSigningType["ESigned"] = "ESigned";
})(VestaTaxTranscriptSigningType || (exports.VestaTaxTranscriptSigningType = VestaTaxTranscriptSigningType = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/TaxReturnDocumentCode
// Only W2 and 1040 are used right now
var VestaTaxReturnDocumentCode;
(function (VestaTaxReturnDocumentCode) {
    VestaTaxReturnDocumentCode["_1040"] = "_1040";
    VestaTaxReturnDocumentCode["_1065"] = "_1065";
    VestaTaxReturnDocumentCode["_1120"] = "_1120";
    VestaTaxReturnDocumentCode["W2"] = "W2";
    VestaTaxReturnDocumentCode["_1098"] = "_1098";
    VestaTaxReturnDocumentCode["_1099"] = "_1099";
    VestaTaxReturnDocumentCode["_5498"] = "_5498";
    VestaTaxReturnDocumentCode["_1120S"] = "_1120S";
})(VestaTaxReturnDocumentCode || (exports.VestaTaxReturnDocumentCode = VestaTaxReturnDocumentCode = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/Form4506CTranscriptType
var VestaForm4506CTranscriptType;
(function (VestaForm4506CTranscriptType) {
    VestaForm4506CTranscriptType["ReturnTranscript"] = "ReturnTranscript";
    VestaForm4506CTranscriptType["AccountTranscript"] = "AccountTranscript";
    VestaForm4506CTranscriptType["RecordOfAccount"] = "RecordOfAccount";
})(VestaForm4506CTranscriptType || (exports.VestaForm4506CTranscriptType = VestaForm4506CTranscriptType = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/PhoneNumberType
var VestaPhoneNumberType;
(function (VestaPhoneNumberType) {
    VestaPhoneNumberType["Home"] = "Home";
    VestaPhoneNumberType["Work"] = "Work";
    VestaPhoneNumberType["Mobile"] = "Mobile";
    VestaPhoneNumberType["Other"] = "Other";
})(VestaPhoneNumberType || (exports.VestaPhoneNumberType = VestaPhoneNumberType = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/MaritalStatus
var VestaMaritalStatus;
(function (VestaMaritalStatus) {
    VestaMaritalStatus["Married"] = "Married";
    VestaMaritalStatus["Separated"] = "Separated";
    VestaMaritalStatus["Unmarried"] = "Unmarried";
})(VestaMaritalStatus || (exports.VestaMaritalStatus = VestaMaritalStatus = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/CreditPullConsentType
var VestaCreditPullConsentType;
(function (VestaCreditPullConsentType) {
    VestaCreditPullConsentType["Verbal"] = "Verbal";
    VestaCreditPullConsentType["Written"] = "Written";
    VestaCreditPullConsentType["Electronic"] = "Electronic";
})(VestaCreditPullConsentType || (exports.VestaCreditPullConsentType = VestaCreditPullConsentType = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/IncomeVerificationConsentType
var VestaIncomeVerificationConsentType;
(function (VestaIncomeVerificationConsentType) {
    VestaIncomeVerificationConsentType["Verbal"] = "Verbal";
    VestaIncomeVerificationConsentType["Written"] = "Written";
    VestaIncomeVerificationConsentType["Electronic"] = "Electronic";
})(VestaIncomeVerificationConsentType || (exports.VestaIncomeVerificationConsentType = VestaIncomeVerificationConsentType = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/ApplicationSubmitMethod
var VestaApplicationSubmitMethod;
(function (VestaApplicationSubmitMethod) {
    VestaApplicationSubmitMethod["Email"] = "Email";
    VestaApplicationSubmitMethod["FaceToFace"] = "FaceToFace";
    VestaApplicationSubmitMethod["Fax"] = "Fax";
    VestaApplicationSubmitMethod["Internet"] = "Internet";
    VestaApplicationSubmitMethod["Mail"] = "Mail";
    VestaApplicationSubmitMethod["Telephone"] = "Telephone";
})(VestaApplicationSubmitMethod || (exports.VestaApplicationSubmitMethod = VestaApplicationSubmitMethod = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/CitizenshipType
var VestaCitizenshipType;
(function (VestaCitizenshipType) {
    VestaCitizenshipType["USCitizen"] = "USCitizen";
    VestaCitizenshipType["PermanentResidentAlien"] = "PermanentResidentAlien";
    VestaCitizenshipType["NonPermanentResidentAlien"] = "NonPermanentResidentAlien";
    VestaCitizenshipType["NonResidentAlien"] = "NonResidentAlien";
})(VestaCitizenshipType || (exports.VestaCitizenshipType = VestaCitizenshipType = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/PriorPropertyUsageType
var VestaPriorPropertyUsageType;
(function (VestaPriorPropertyUsageType) {
    VestaPriorPropertyUsageType["Investment"] = "Investment";
    VestaPriorPropertyUsageType["PrimaryResidence"] = "PrimaryResidence";
    VestaPriorPropertyUsageType["SecondHome"] = "SecondHome";
    VestaPriorPropertyUsageType["FHASecondaryResidence"] = "FHASecondaryResidence";
})(VestaPriorPropertyUsageType || (exports.VestaPriorPropertyUsageType = VestaPriorPropertyUsageType = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/PriorPropertyTitleType
var VestaPriorPropertyTitleType;
(function (VestaPriorPropertyTitleType) {
    VestaPriorPropertyTitleType["JointWithOtherThanSpouse"] = "JointWithOtherThanSpouse";
    VestaPriorPropertyTitleType["JointWithSpouse"] = "JointWithSpouse";
    VestaPriorPropertyTitleType["Sole"] = "Sole";
})(VestaPriorPropertyTitleType || (exports.VestaPriorPropertyTitleType = VestaPriorPropertyTitleType = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/BankruptcyChapterType
var VestaBankruptcyChapterType;
(function (VestaBankruptcyChapterType) {
    VestaBankruptcyChapterType["ChapterSeven"] = "ChapterSeven";
    VestaBankruptcyChapterType["ChapterEleven"] = "ChapterEleven";
    VestaBankruptcyChapterType["ChapterTwelve"] = "ChapterTwelve";
    VestaBankruptcyChapterType["ChapterThirteen"] = "ChapterThirteen";
})(VestaBankruptcyChapterType || (exports.VestaBankruptcyChapterType = VestaBankruptcyChapterType = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/BankruptcyClosedType
var VestaBankruptcyClosedType;
(function (VestaBankruptcyClosedType) {
    VestaBankruptcyClosedType["Discharged"] = "Discharged";
    VestaBankruptcyClosedType["Dismissed"] = "Dismissed";
})(VestaBankruptcyClosedType || (exports.VestaBankruptcyClosedType = VestaBankruptcyClosedType = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/HmdaEthnicityOriginType
var VestaHmdaEthnicityOriginType;
(function (VestaHmdaEthnicityOriginType) {
    VestaHmdaEthnicityOriginType["Mexican"] = "Mexican";
    VestaHmdaEthnicityOriginType["PuertoRican"] = "PuertoRican";
    VestaHmdaEthnicityOriginType["Cuban"] = "Cuban";
    VestaHmdaEthnicityOriginType["Other"] = "Other";
})(VestaHmdaEthnicityOriginType || (exports.VestaHmdaEthnicityOriginType = VestaHmdaEthnicityOriginType = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/HmdaEthnicityType
var VestaHmdaEthnicityType;
(function (VestaHmdaEthnicityType) {
    VestaHmdaEthnicityType["HispanicOrLatino"] = "HispanicOrLatino";
    VestaHmdaEthnicityType["NotHispanicOrLatino"] = "NotHispanicOrLatino";
    VestaHmdaEthnicityType["PreferNotToDisclose"] = "PreferNotToDisclose";
})(VestaHmdaEthnicityType || (exports.VestaHmdaEthnicityType = VestaHmdaEthnicityType = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/HMDAGenderType
var VestaHmdaGenderType;
(function (VestaHmdaGenderType) {
    VestaHmdaGenderType["Male"] = "Male";
    VestaHmdaGenderType["Female"] = "Female";
    VestaHmdaGenderType["PreferNotToDisclose"] = "PreferNotToDisclose";
})(VestaHmdaGenderType || (exports.VestaHmdaGenderType = VestaHmdaGenderType = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/HMDARaceType
var VestaHmdaRaceType;
(function (VestaHmdaRaceType) {
    VestaHmdaRaceType["AmericanIndianOrAlaskaNative"] = "AmericanIndianOrAlaskaNative";
    VestaHmdaRaceType["Asian"] = "Asian";
    VestaHmdaRaceType["BlackOrAfricanAmerican"] = "BlackOrAfricanAmerican";
    VestaHmdaRaceType["NativeHawaiianOrOtherPacificIslander"] = "NativeHawaiianOrOtherPacificIslander";
    VestaHmdaRaceType["White"] = "White";
    VestaHmdaRaceType["PreferNotToDisclose"] = "PreferNotToDisclose";
})(VestaHmdaRaceType || (exports.VestaHmdaRaceType = VestaHmdaRaceType = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/HMDARaceDesignationType
var VestaHmdaRaceDesignationType;
(function (VestaHmdaRaceDesignationType) {
    VestaHmdaRaceDesignationType["AsianIndian"] = "AsianIndian";
    VestaHmdaRaceDesignationType["Chinese"] = "Chinese";
    VestaHmdaRaceDesignationType["Filipino"] = "Filipino";
    VestaHmdaRaceDesignationType["Japanese"] = "Japanese";
    VestaHmdaRaceDesignationType["Korean"] = "Korean";
    VestaHmdaRaceDesignationType["OtherAsian"] = "OtherAsian";
    VestaHmdaRaceDesignationType["Vietnamese"] = "Vietnamese";
})(VestaHmdaRaceDesignationType || (exports.VestaHmdaRaceDesignationType = VestaHmdaRaceDesignationType = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/HMDARaceDesignationTypePacificIslander
var VestaHmdaRaceDesignationTypePacificIslander;
(function (VestaHmdaRaceDesignationTypePacificIslander) {
    VestaHmdaRaceDesignationTypePacificIslander["GuamanianOrChamorro"] = "GuamanianOrChamorro";
    VestaHmdaRaceDesignationTypePacificIslander["NativeHawaiian"] = "NativeHawaiian";
    VestaHmdaRaceDesignationTypePacificIslander["OtherPacificIslander"] = "OtherPacificIslander";
    VestaHmdaRaceDesignationTypePacificIslander["Samoan"] = "Samoan";
})(VestaHmdaRaceDesignationTypePacificIslander || (exports.VestaHmdaRaceDesignationTypePacificIslander = VestaHmdaRaceDesignationTypePacificIslander = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/AssetType
var VestaAssetType;
(function (VestaAssetType) {
    VestaAssetType["Bond"] = "Bond";
    VestaAssetType["BridgeLoanNotDeposited"] = "BridgeLoanNotDeposited";
    VestaAssetType["CertificateOfDepositTimeDeposit"] = "CertificateOfDepositTimeDeposit";
    VestaAssetType["CheckingAccount"] = "CheckingAccount";
    VestaAssetType["IndividualDevelopmentAccount"] = "IndividualDevelopmentAccount";
    VestaAssetType["LifeInsurance"] = "LifeInsurance";
    VestaAssetType["MoneyMarketFund"] = "MoneyMarketFund";
    VestaAssetType["MutualFund"] = "MutualFund";
    VestaAssetType["RetirementFund"] = "RetirementFund";
    VestaAssetType["SavingsAccount"] = "SavingsAccount";
    VestaAssetType["Stock"] = "Stock";
    VestaAssetType["StockOptions"] = "StockOptions";
    VestaAssetType["TrustAccount"] = "TrustAccount";
    VestaAssetType["CashOnHand"] = "CashOnHand";
    VestaAssetType["Other"] = "Other";
    VestaAssetType["PendingNetSaleProceedsFromRealEstateAssets"] = "PendingNetSaleProceedsFromRealEstateAssets";
    VestaAssetType["ProceedsFromSaleOfNonRealEstateAsset"] = "ProceedsFromSaleOfNonRealEstateAsset";
    VestaAssetType["ProceedsFromSecuredLoan"] = "ProceedsFromSecuredLoan";
    VestaAssetType["ProceedsFromUnsecuredLoan"] = "ProceedsFromUnsecuredLoan";
    VestaAssetType["GiftOfCash"] = "GiftOfCash";
    VestaAssetType["Grant"] = "Grant";
})(VestaAssetType || (exports.VestaAssetType = VestaAssetType = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/IncomeType
var VestaIncomeType;
(function (VestaIncomeType) {
    VestaIncomeType["AccessoryUnit"] = "AccessoryUnit";
    VestaIncomeType["Alimony"] = "Alimony";
    VestaIncomeType["AutomobileAllowance"] = "AutomobileAllowance";
    VestaIncomeType["Boarder"] = "Boarder";
    VestaIncomeType["CapitalGains"] = "CapitalGains";
    VestaIncomeType["ChildSupport"] = "ChildSupport";
    VestaIncomeType["DividendsInterest"] = "DividendsInterest";
    VestaIncomeType["Employment"] = "Employment";
    VestaIncomeType["FosterCare"] = "FosterCare";
    VestaIncomeType["HousingAllowance"] = "HousingAllowance";
    VestaIncomeType["HousingChoiceVoucherProgram"] = "HousingChoiceVoucherProgram";
    VestaIncomeType["MortgageCreditCertificate"] = "MortgageCreditCertificate";
    VestaIncomeType["MortgageDifferential"] = "MortgageDifferential";
    VestaIncomeType["NotesReceivableInstallment"] = "NotesReceivableInstallment";
    VestaIncomeType["Other"] = "Other";
    VestaIncomeType["Pension"] = "Pension";
    VestaIncomeType["PublicAssistance"] = "PublicAssistance";
    VestaIncomeType["Rental"] = "Rental";
    VestaIncomeType["Retirement"] = "Retirement";
    VestaIncomeType["Royalties"] = "Royalties";
    VestaIncomeType["SelfEmployment"] = "SelfEmployment";
    VestaIncomeType["SeparateMaintenance"] = "SeparateMaintenance";
    VestaIncomeType["SocialSecurity"] = "SocialSecurity";
    VestaIncomeType["TemporaryLeave"] = "TemporaryLeave";
    VestaIncomeType["Trust"] = "Trust";
    VestaIncomeType["UnemploymentBenefits"] = "UnemploymentBenefits";
    VestaIncomeType["VABenefitsNonEducational"] = "VABenefitsNonEducational";
    VestaIncomeType["Disability"] = "Disability";
})(VestaIncomeType || (exports.VestaIncomeType = VestaIncomeType = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/IncomeAmountType
var VestaIncomeAmountType;
(function (VestaIncomeAmountType) {
    VestaIncomeAmountType["Weekly"] = "Weekly";
    VestaIncomeAmountType["BiWeekly"] = "BiWeekly";
    VestaIncomeAmountType["SemiMonthly"] = "SemiMonthly";
    VestaIncomeAmountType["Monthly"] = "Monthly";
    VestaIncomeAmountType["Quarterly"] = "Quarterly";
    VestaIncomeAmountType["SemiYearly"] = "SemiYearly";
    VestaIncomeAmountType["Annual"] = "Annual";
    VestaIncomeAmountType["AsOf"] = "AsOf";
    VestaIncomeAmountType["Hourly"] = "Hourly";
})(VestaIncomeAmountType || (exports.VestaIncomeAmountType = VestaIncomeAmountType = {}));
var VestaEmployerStatus;
(function (VestaEmployerStatus) {
    VestaEmployerStatus["Current"] = "Current";
    VestaEmployerStatus["Previous"] = "Previous";
})(VestaEmployerStatus || (exports.VestaEmployerStatus = VestaEmployerStatus = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/LiabilityType
/**  @TranslateToPython @TranslateToEnum  */
var VestaLiabilityType;
(function (VestaLiabilityType) {
    VestaLiabilityType["CollectionsJudgmentsAndLiens"] = "CollectionsJudgmentsAndLiens";
    VestaLiabilityType["UnsecuredInstallment"] = "UnsecuredInstallment";
    VestaLiabilityType["SecuredInstallment"] = "SecuredInstallment";
    VestaLiabilityType["LeasePayment"] = "LeasePayment";
    VestaLiabilityType["Open30DayChargeAccount"] = "Open30DayChargeAccount";
    VestaLiabilityType["RevolvingCreditLine"] = "RevolvingCreditLine";
    VestaLiabilityType["Taxes"] = "Taxes";
    VestaLiabilityType["TaxLien"] = "TaxLien";
    VestaLiabilityType["HELOC"] = "HELOC";
    VestaLiabilityType["HomeEquityLoan"] = "HomeEquityLoan";
    VestaLiabilityType["PACELoan"] = "PACELoan";
    VestaLiabilityType["Mortgage"] = "Mortgage";
    VestaLiabilityType["OtherLiability"] = "OtherLiability";
    VestaLiabilityType["Alimony"] = "Alimony";
    VestaLiabilityType["ChildSupport"] = "ChildSupport";
    VestaLiabilityType["JobRelatedExpenses"] = "JobRelatedExpenses";
    VestaLiabilityType["SeparateMaintenanceExpense"] = "SeparateMaintenanceExpense";
    VestaLiabilityType["OtherExpense"] = "OtherExpense";
    VestaLiabilityType["EquityBuyout"] = "EquityBuyout";
    VestaLiabilityType["DeferredStudentLoan"] = "DeferredStudentLoan";
})(VestaLiabilityType || (exports.VestaLiabilityType = VestaLiabilityType = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/LiabilitySubtype
var VestaLiabilitySubtype;
(function (VestaLiabilitySubtype) {
    VestaLiabilitySubtype["Agriculture"] = "Agriculture";
    VestaLiabilitySubtype["Airplane"] = "Airplane";
    VestaLiabilitySubtype["ApplianceOrFurniture"] = "ApplianceOrFurniture";
    VestaLiabilitySubtype["AttorneyFees"] = "AttorneyFees";
    VestaLiabilitySubtype["AutoLease"] = "AutoLease";
    VestaLiabilitySubtype["AutoLoanEquityTransfer"] = "AutoLoanEquityTransfer";
    VestaLiabilitySubtype["Automobile"] = "Automobile";
    VestaLiabilitySubtype["AutoRefinance"] = "AutoRefinance";
    VestaLiabilitySubtype["BiMonthlyMortgageTermsInYears"] = "BiMonthlyMortgageTermsInYears";
    VestaLiabilitySubtype["Boat"] = "Boat";
    VestaLiabilitySubtype["Business"] = "Business";
    VestaLiabilitySubtype["BusinessCreditCard"] = "BusinessCreditCard";
    VestaLiabilitySubtype["Camper"] = "Camper";
    VestaLiabilitySubtype["ChargeAccount"] = "ChargeAccount";
    VestaLiabilitySubtype["CheckCreditOrLineOfCredit"] = "CheckCreditOrLineOfCredit";
    VestaLiabilitySubtype["ChildSupport"] = "ChildSupport";
    VestaLiabilitySubtype["Collection"] = "Collection";
    VestaLiabilitySubtype["CollectionAttorney"] = "CollectionAttorney";
    VestaLiabilitySubtype["Comaker"] = "Comaker";
    VestaLiabilitySubtype["CombinedCreditPlan"] = "CombinedCreditPlan";
    VestaLiabilitySubtype["CommercialCreditObligation"] = "CommercialCreditObligation";
    VestaLiabilitySubtype["CommercialLineOfCredit"] = "CommercialLineOfCredit";
    VestaLiabilitySubtype["CommercialMortgage"] = "CommercialMortgage";
    VestaLiabilitySubtype["ConditionalSalesContract"] = "ConditionalSalesContract";
    VestaLiabilitySubtype["ConditionalSalesContractRefinance"] = "ConditionalSalesContractRefinance";
    VestaLiabilitySubtype["Consolidation"] = "Consolidation";
    VestaLiabilitySubtype["ConstructionLoan"] = "ConstructionLoan";
    VestaLiabilitySubtype["ConventionalRealEstateMortgage"] = "ConventionalRealEstateMortgage";
    VestaLiabilitySubtype["CreditCard"] = "CreditCard";
    VestaLiabilitySubtype["CreditLineSecured"] = "CreditLineSecured";
    VestaLiabilitySubtype["DebitCard"] = "DebitCard";
    VestaLiabilitySubtype["DebtCounselingService"] = "DebtCounselingService";
    VestaLiabilitySubtype["DeferredStudentLoan"] = "DeferredStudentLoan";
    VestaLiabilitySubtype["DepositRelated"] = "DepositRelated";
    VestaLiabilitySubtype["Educational"] = "Educational";
    VestaLiabilitySubtype["Employment"] = "Employment";
    VestaLiabilitySubtype["FactoringCompanyAccount"] = "FactoringCompanyAccount";
    VestaLiabilitySubtype["FamilySupport"] = "FamilySupport";
    VestaLiabilitySubtype["FarmersHomeAdministrationFHMA"] = "FarmersHomeAdministrationFHMA";
    VestaLiabilitySubtype["FederalConsolidatedLoan"] = "FederalConsolidatedLoan";
    VestaLiabilitySubtype["FHAComakerNotBorrower"] = "FHAComakerNotBorrower";
    VestaLiabilitySubtype["FHAHomeImprovement"] = "FHAHomeImprovement";
    VestaLiabilitySubtype["FHARealEstateMortgage"] = "FHARealEstateMortgage";
    VestaLiabilitySubtype["FinanceStatement"] = "FinanceStatement";
    VestaLiabilitySubtype["GovernmentBenefit"] = "GovernmentBenefit";
    VestaLiabilitySubtype["GovernmentEmployeeAdvance"] = "GovernmentEmployeeAdvance";
    VestaLiabilitySubtype["GovernmentFeeForService"] = "GovernmentFeeForService";
    VestaLiabilitySubtype["GovernmentFine"] = "GovernmentFine";
    VestaLiabilitySubtype["GovernmentGrant"] = "GovernmentGrant";
    VestaLiabilitySubtype["GovernmentMiscellaneousDebt"] = "GovernmentMiscellaneousDebt";
    VestaLiabilitySubtype["GovernmentOverpayment"] = "GovernmentOverpayment";
    VestaLiabilitySubtype["GovernmentSecuredDirectLoan"] = "GovernmentSecuredDirectLoan";
    VestaLiabilitySubtype["GovernmentSecuredGuaranteeLoan"] = "GovernmentSecuredGuaranteeLoan";
    VestaLiabilitySubtype["GovernmentUnsecuredDirectLoan"] = "GovernmentUnsecuredDirectLoan";
    VestaLiabilitySubtype["GovernmentUnsecuredGuaranteeLoan"] = "GovernmentUnsecuredGuaranteeLoan";
    VestaLiabilitySubtype["HomeEquity"] = "HomeEquity";
    VestaLiabilitySubtype["HomeEquityLineOfCredit"] = "HomeEquityLineOfCredit";
    VestaLiabilitySubtype["HomeImprovement"] = "HomeImprovement";
    VestaLiabilitySubtype["HouseholdGoods"] = "HouseholdGoods";
    VestaLiabilitySubtype["HouseholdGoodsAndOtherCollateralAuto"] = "HouseholdGoodsAndOtherCollateralAuto";
    VestaLiabilitySubtype["HouseholdGoodsSecured"] = "HouseholdGoodsSecured";
    VestaLiabilitySubtype["InstallmentLoan"] = "InstallmentLoan";
    VestaLiabilitySubtype["InstallmentSalesContract"] = "InstallmentSalesContract";
    VestaLiabilitySubtype["InsuranceClaims"] = "InsuranceClaims";
    VestaLiabilitySubtype["Lease"] = "Lease";
    VestaLiabilitySubtype["LenderPlacedInsurance"] = "LenderPlacedInsurance";
    VestaLiabilitySubtype["ManualMortgage"] = "ManualMortgage";
    VestaLiabilitySubtype["ManufacturedHome"] = "ManufacturedHome";
    VestaLiabilitySubtype["MedicalDebt"] = "MedicalDebt";
    VestaLiabilitySubtype["MobileHome"] = "MobileHome";
    VestaLiabilitySubtype["MobilePhone"] = "MobilePhone";
    VestaLiabilitySubtype["Mortgage"] = "Mortgage";
    VestaLiabilitySubtype["NoteLoan"] = "NoteLoan";
    VestaLiabilitySubtype["NoteLoanWithComaker"] = "NoteLoanWithComaker";
    VestaLiabilitySubtype["Other"] = "Other";
    VestaLiabilitySubtype["PartiallySecured"] = "PartiallySecured";
    VestaLiabilitySubtype["PersonalLoan"] = "PersonalLoan";
    VestaLiabilitySubtype["RealEstateJuniorLiens"] = "RealEstateJuniorLiens";
    VestaLiabilitySubtype["RealEstateLoanEquityTransfer"] = "RealEstateLoanEquityTransfer";
    VestaLiabilitySubtype["RealEstateMortgageWithoutOtherCollateral"] = "RealEstateMortgageWithoutOtherCollateral";
    VestaLiabilitySubtype["RealEstateSpecificTypeUnknown"] = "RealEstateSpecificTypeUnknown";
    VestaLiabilitySubtype["Recreational"] = "Recreational";
    VestaLiabilitySubtype["RecreationalVehicle"] = "RecreationalVehicle";
    VestaLiabilitySubtype["Refinance"] = "Refinance";
    VestaLiabilitySubtype["RefundAnticipationLoan"] = "RefundAnticipationLoan";
    VestaLiabilitySubtype["RentalAgreement"] = "RentalAgreement";
    VestaLiabilitySubtype["ResidentialLoan"] = "ResidentialLoan";
    VestaLiabilitySubtype["ReturnedCheck"] = "ReturnedCheck";
    VestaLiabilitySubtype["RevolvingBusinessLines"] = "RevolvingBusinessLines";
    VestaLiabilitySubtype["SecondMortgage"] = "SecondMortgage";
    VestaLiabilitySubtype["Secured"] = "Secured";
    VestaLiabilitySubtype["SecuredByCosigner"] = "SecuredByCosigner";
    VestaLiabilitySubtype["SecuredCreditCard"] = "SecuredCreditCard";
    VestaLiabilitySubtype["SecuredHomeImprovement"] = "SecuredHomeImprovement";
    VestaLiabilitySubtype["SemiMonthlyMortgagePayment"] = "SemiMonthlyMortgagePayment";
    VestaLiabilitySubtype["SinglePaymentLoan"] = "SinglePaymentLoan";
    VestaLiabilitySubtype["SpouseSupport"] = "SpouseSupport";
    VestaLiabilitySubtype["SummaryOfAccountsWithSameStatus"] = "SummaryOfAccountsWithSameStatus";
    VestaLiabilitySubtype["TimeSharedLoan"] = "TimeSharedLoan";
    VestaLiabilitySubtype["Title1Loan"] = "Title1Loan";
    VestaLiabilitySubtype["UnknownLoanType"] = "UnknownLoanType";
    VestaLiabilitySubtype["Unsecured"] = "Unsecured";
    VestaLiabilitySubtype["UtilityCompany"] = "UtilityCompany";
    VestaLiabilitySubtype["VeteransAdministrationLoan"] = "VeteransAdministrationLoan";
    VestaLiabilitySubtype["VeteransAdministrationRealEstateMortgage"] = "VeteransAdministrationRealEstateMortgage";
})(VestaLiabilitySubtype || (exports.VestaLiabilitySubtype = VestaLiabilitySubtype = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/LiabilityIntent
var VestaLiabilityIntent;
(function (VestaLiabilityIntent) {
    VestaLiabilityIntent["DoNothing"] = "DoNothing";
    VestaLiabilityIntent["PayAtClosing"] = "PayAtClosing";
    VestaLiabilityIntent["PayBeforeClosing"] = "PayBeforeClosing";
    VestaLiabilityIntent["Subordinate"] = "Subordinate";
    VestaLiabilityIntent["ExcludeLessThan10MonthsLeft"] = "ExcludeLessThan10MonthsLeft";
    VestaLiabilityIntent["ExcludePaidByOthers"] = "ExcludePaidByOthers";
    VestaLiabilityIntent["ExcludeAssignedToAnotherParty"] = "ExcludeAssignedToAnotherParty";
    VestaLiabilityIntent["ExcludeAssociatedPropertySold"] = "ExcludeAssociatedPropertySold";
    VestaLiabilityIntent["ExcludeBusinessDebtPaidFromBusinessFunds"] = "ExcludeBusinessDebtPaidFromBusinessFunds";
    VestaLiabilityIntent["ExcludeDebtIsAssetCollateralized"] = "ExcludeDebtIsAssetCollateralized";
    VestaLiabilityIntent["ExcludeNonApplicantDebt"] = "ExcludeNonApplicantDebt";
    VestaLiabilityIntent["ExcludeRentalPaymentFromPreviousResidence"] = "ExcludeRentalPaymentFromPreviousResidence";
    VestaLiabilityIntent["ExcludeOther"] = "ExcludeOther";
    VestaLiabilityIntent["Exclude30DayChargeAccount"] = "Exclude30DayChargeAccount";
    VestaLiabilityIntent["ExcludeUtilities"] = "ExcludeUtilities";
})(VestaLiabilityIntent || (exports.VestaLiabilityIntent = VestaLiabilityIntent = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/LiabilityAccountStatus
var VestaLiabilityAccountStatus;
(function (VestaLiabilityAccountStatus) {
    VestaLiabilityAccountStatus["Closed"] = "Closed";
    VestaLiabilityAccountStatus["Frozen"] = "Frozen";
    VestaLiabilityAccountStatus["Open"] = "Open";
    VestaLiabilityAccountStatus["Paid"] = "Paid";
    VestaLiabilityAccountStatus["Refinanced"] = "Refinanced";
    VestaLiabilityAccountStatus["Transferred"] = "Transferred";
})(VestaLiabilityAccountStatus || (exports.VestaLiabilityAccountStatus = VestaLiabilityAccountStatus = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/EconsentCaptureMethod
var VestaEconsentCaptureMethod;
(function (VestaEconsentCaptureMethod) {
    VestaEconsentCaptureMethod["Electronic"] = "Electronic";
    VestaEconsentCaptureMethod["Verbal"] = "Verbal";
})(VestaEconsentCaptureMethod || (exports.VestaEconsentCaptureMethod = VestaEconsentCaptureMethod = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/EconsentStatus
var VestaEconsentStatus;
(function (VestaEconsentStatus) {
    VestaEconsentStatus["Accept"] = "Accept";
    VestaEconsentStatus["Decline"] = "Decline";
    VestaEconsentStatus["Withdrawn"] = "Withdrawn";
})(VestaEconsentStatus || (exports.VestaEconsentStatus = VestaEconsentStatus = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/LoanAmortizationType
// @TranslateToPython
var VestaLoanAmortizationType;
(function (VestaLoanAmortizationType) {
    VestaLoanAmortizationType["FixedRateMortgage"] = "FixedRateMortgage";
    VestaLoanAmortizationType["AdjustableRateMortgage"] = "AdjustableRateMortgage";
    VestaLoanAmortizationType["GrowingEquityMortgage"] = "GrowingEquityMortgage";
    VestaLoanAmortizationType["GraduatedPaymentMortgage"] = "GraduatedPaymentMortgage";
    VestaLoanAmortizationType["StepRateMortgage"] = "StepRateMortgage";
    VestaLoanAmortizationType["Other"] = "Other";
})(VestaLoanAmortizationType || (exports.VestaLoanAmortizationType = VestaLoanAmortizationType = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/QuoteStatus
var VestaQuoteStatus;
(function (VestaQuoteStatus) {
    VestaQuoteStatus["Active"] = "Active";
    VestaQuoteStatus["UpdateInProgress"] = "UpdateInProgress";
    VestaQuoteStatus["Expired"] = "Expired";
    VestaQuoteStatus["Suspended"] = "Suspended";
})(VestaQuoteStatus || (exports.VestaQuoteStatus = VestaQuoteStatus = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/MortgageSizeType
var VestaMortgageSizeType;
(function (VestaMortgageSizeType) {
    VestaMortgageSizeType["Conforming"] = "Conforming";
    VestaMortgageSizeType["HighBalance"] = "HighBalance";
    VestaMortgageSizeType["Jumbo"] = "Jumbo";
})(VestaMortgageSizeType || (exports.VestaMortgageSizeType = VestaMortgageSizeType = {}));
var VestaQuotePricingScenariosQueryType;
(function (VestaQuotePricingScenariosQueryType) {
    VestaQuotePricingScenariosQueryType["InitialQuery"] = "InitialQuery";
    VestaQuotePricingScenariosQueryType["Reprice"] = "Reprice";
    VestaQuotePricingScenariosQueryType["RequestReprice"] = "RequestReprice";
    VestaQuotePricingScenariosQueryType["RequestRelock"] = "RequestRelock";
    VestaQuotePricingScenariosQueryType["HistoricalPricing"] = "HistoricalPricing";
    VestaQuotePricingScenariosQueryType["Relock"] = "Relock";
})(VestaQuotePricingScenariosQueryType || (exports.VestaQuotePricingScenariosQueryType = VestaQuotePricingScenariosQueryType = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/CompensationPaidByType
var VestaCompensationPaidByType;
(function (VestaCompensationPaidByType) {
    VestaCompensationPaidByType["Borrower"] = "Borrower";
    VestaCompensationPaidByType["Lender"] = "Lender";
})(VestaCompensationPaidByType || (exports.VestaCompensationPaidByType = VestaCompensationPaidByType = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/CreditPullActionType
var VestaCreditPullActionType;
(function (VestaCreditPullActionType) {
    VestaCreditPullActionType["PullNew"] = "PullNew";
    VestaCreditPullActionType["Upgrade"] = "Upgrade";
    VestaCreditPullActionType["Retrieve"] = "Retrieve";
})(VestaCreditPullActionType || (exports.VestaCreditPullActionType = VestaCreditPullActionType = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/CreditPullType
var VestaCreditPullType;
(function (VestaCreditPullType) {
    VestaCreditPullType["Hard"] = "Hard";
    VestaCreditPullType["Soft"] = "Soft";
})(VestaCreditPullType || (exports.VestaCreditPullType = VestaCreditPullType = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/CreditPullRequestType
var VestaCreditPullRequestType;
(function (VestaCreditPullRequestType) {
    VestaCreditPullRequestType["Individual"] = "Individual";
    VestaCreditPullRequestType["Joint"] = "Joint";
})(VestaCreditPullRequestType || (exports.VestaCreditPullRequestType = VestaCreditPullRequestType = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/CreditExternalProviderType
// We only support CredCo for now
var VestaCreditExternalProviderType;
(function (VestaCreditExternalProviderType) {
    VestaCreditExternalProviderType["CredCo"] = "CredCo";
})(VestaCreditExternalProviderType || (exports.VestaCreditExternalProviderType = VestaCreditExternalProviderType = {}));
// We define this ourselves, but the standard package types are InitialDisclosure, Redisclosure, ClosingDisclosure, and Closing
// As of 2025-02-24, we only support InitialDisclosure
var VestaDisclosurePackageType;
(function (VestaDisclosurePackageType) {
    VestaDisclosurePackageType["InitialDisclosure"] = "InitialDisclosure";
})(VestaDisclosurePackageType || (exports.VestaDisclosurePackageType = VestaDisclosurePackageType = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/DisclosureProvider
var VestaDisclosureProvider;
(function (VestaDisclosureProvider) {
    VestaDisclosureProvider["Docutech"] = "Docutech";
})(VestaDisclosureProvider || (exports.VestaDisclosureProvider = VestaDisclosureProvider = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/DisclosureStatus
var VestaDisclosureStatus;
(function (VestaDisclosureStatus) {
    VestaDisclosureStatus["Sent"] = "Sent";
    VestaDisclosureStatus["Completed"] = "Completed";
    VestaDisclosureStatus["Cancelled"] = "Cancelled";
    VestaDisclosureStatus["Failed"] = "Failed";
    VestaDisclosureStatus["Sending"] = "Sending";
    VestaDisclosureStatus["Expired"] = "Expired";
})(VestaDisclosureStatus || (exports.VestaDisclosureStatus = VestaDisclosureStatus = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/DisclosureRecipientType
var VestaDisclosureRecipientType;
(function (VestaDisclosureRecipientType) {
    VestaDisclosureRecipientType["Borrower"] = "Borrower";
    VestaDisclosureRecipientType["Lender"] = "Lender";
    VestaDisclosureRecipientType["ThirdParty"] = "ThirdParty";
})(VestaDisclosureRecipientType || (exports.VestaDisclosureRecipientType = VestaDisclosureRecipientType = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/ClosingAdjustmentType
var VestaClosingAdjustmentType;
(function (VestaClosingAdjustmentType) {
    VestaClosingAdjustmentType["FuelCosts"] = "FuelCosts";
    VestaClosingAdjustmentType["LenderCredit"] = "LenderCredit";
    VestaClosingAdjustmentType["RentFromSubjectProperty"] = "RentFromSubjectProperty";
    VestaClosingAdjustmentType["RepairCompletionEscrowHoldback"] = "RepairCompletionEscrowHoldback";
    VestaClosingAdjustmentType["Repairs"] = "Repairs";
    VestaClosingAdjustmentType["SatisfactionOfSubordinateLien"] = "SatisfactionOfSubordinateLien";
    VestaClosingAdjustmentType["SellersEscrowAssumption"] = "SellersEscrowAssumption";
    VestaClosingAdjustmentType["SellersMortgageInsuranceAssumption"] = "SellersMortgageInsuranceAssumption";
    VestaClosingAdjustmentType["SellersReserveAccountAssumption"] = "SellersReserveAccountAssumption";
    VestaClosingAdjustmentType["Services"] = "Services";
    VestaClosingAdjustmentType["TenantSecurityDeposit"] = "TenantSecurityDeposit";
    VestaClosingAdjustmentType["UnpaidUtilityEscrowHoldback"] = "UnpaidUtilityEscrowHoldback";
    VestaClosingAdjustmentType["Other"] = "Other";
    VestaClosingAdjustmentType["RebateCredit"] = "RebateCredit";
    VestaClosingAdjustmentType["SubordinateFinancingProceeds"] = "SubordinateFinancingProceeds";
    VestaClosingAdjustmentType["LenderCreditToleranceCures"] = "LenderCreditToleranceCures";
    VestaClosingAdjustmentType["LenderCreditPoints"] = "LenderCreditPoints";
    VestaClosingAdjustmentType["AdditionalSaleOfSellerProperty"] = "AdditionalSaleOfSellerProperty";
    VestaClosingAdjustmentType["GiftOfEquity"] = "GiftOfEquity";
    VestaClosingAdjustmentType["RelocationFunds"] = "RelocationFunds";
    VestaClosingAdjustmentType["SweatEquity"] = "SweatEquity";
    VestaClosingAdjustmentType["TradeEquity"] = "TradeEquity";
    VestaClosingAdjustmentType["ManagedLenderCredit"] = "ManagedLenderCredit";
    VestaClosingAdjustmentType["LenderCreditConcession"] = "LenderCreditConcession";
    VestaClosingAdjustmentType["EmployerAssistedHousing"] = "EmployerAssistedHousing";
    VestaClosingAdjustmentType["LeasePurchaseFund"] = "LeasePurchaseFund";
    VestaClosingAdjustmentType["LotEquity"] = "LotEquity";
})(VestaClosingAdjustmentType || (exports.VestaClosingAdjustmentType = VestaClosingAdjustmentType = {}));
var VestaClosingAdjustmentPaidToOrFromBorrower;
(function (VestaClosingAdjustmentPaidToOrFromBorrower) {
    VestaClosingAdjustmentPaidToOrFromBorrower["ToBorrower"] = "ToBorrower";
    VestaClosingAdjustmentPaidToOrFromBorrower["FromBorrower"] = "FromBorrower";
})(VestaClosingAdjustmentPaidToOrFromBorrower || (exports.VestaClosingAdjustmentPaidToOrFromBorrower = VestaClosingAdjustmentPaidToOrFromBorrower = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/FeeCategory
var VestaFeeCategory;
(function (VestaFeeCategory) {
    VestaFeeCategory["OriginationCharges"] = "OriginationCharges";
    VestaFeeCategory["ThirdPartyServices"] = "ThirdPartyServices";
    VestaFeeCategory["TaxesAndGovernmentFees"] = "TaxesAndGovernmentFees";
    VestaFeeCategory["Prepaids"] = "Prepaids";
    VestaFeeCategory["InitialEscrowPayments"] = "InitialEscrowPayments";
    VestaFeeCategory["Other"] = "Other";
})(VestaFeeCategory || (exports.VestaFeeCategory = VestaFeeCategory = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/FeeType
var VestaFeeType;
(function (VestaFeeType) {
    VestaFeeType["Other"] = "Other";
    VestaFeeType["ApplicationFee"] = "ApplicationFee";
    VestaFeeType["AppraisalDeskReviewFee"] = "AppraisalDeskReviewFee";
    VestaFeeType["AttorneyFee"] = "AttorneyFee";
    VestaFeeType["CommitmentFee"] = "CommitmentFee";
    VestaFeeType["LenderCourierFee"] = "LenderCourierFee";
    VestaFeeType["EscrowHoldbackFee"] = "EscrowHoldbackFee";
    VestaFeeType["EscrowWaiverFee"] = "EscrowWaiverFee";
    VestaFeeType["LendersAttorneyFee"] = "LendersAttorneyFee";
    VestaFeeType["LoanOriginationFee"] = "LoanOriginationFee";
    VestaFeeType["MortgageBrokerFee"] = "MortgageBrokerFee";
    VestaFeeType["PayoffRequestFee"] = "PayoffRequestFee";
    VestaFeeType["ProcessingFee"] = "ProcessingFee";
    VestaFeeType["RateLockFee"] = "RateLockFee";
    VestaFeeType["SubordinationFee"] = "SubordinationFee";
    VestaFeeType["UnderwritingFee"] = "UnderwritingFee";
    VestaFeeType["WireTransferFee"] = "WireTransferFee";
    VestaFeeType["LenderCertificationFee"] = "LenderCertificationFee";
    VestaFeeType["LenderCopyOrFaxFee"] = "LenderCopyOrFaxFee";
    VestaFeeType["LenderDocumentPreparationFee"] = "LenderDocumentPreparationFee";
    VestaFeeType["LenderElectronicDocumentDeliveryFee"] = "LenderElectronicDocumentDeliveryFee";
    VestaFeeType["LenderFilingFee"] = "LenderFilingFee";
    VestaFeeType["LockExtensionFee"] = "LockExtensionFee";
    VestaFeeType["LenderTaxServiceFee"] = "LenderTaxServiceFee";
    VestaFeeType["AssumptionFee"] = "AssumptionFee";
    VestaFeeType["Points"] = "Points";
    VestaFeeType["HomeInspectionFee"] = "HomeInspectionFee";
    VestaFeeType["HomeownersAssociationDues"] = "HomeownersAssociationDues";
    VestaFeeType["HomeownersAssociationServiceFee"] = "HomeownersAssociationServiceFee";
    VestaFeeType["HomeownersAssociationSpecialAssessment"] = "HomeownersAssociationSpecialAssessment";
    VestaFeeType["HomeWarrantyFee"] = "HomeWarrantyFee";
    VestaFeeType["RealEstateCommissionBuyersBroker"] = "RealEstateCommissionBuyersBroker";
    VestaFeeType["RealEstateCommissionSellersBroker"] = "RealEstateCommissionSellersBroker";
    VestaFeeType["TitleOwnersCoveragePremium"] = "TitleOwnersCoveragePremium";
    VestaFeeType["TemporaryBuydownPoints"] = "TemporaryBuydownPoints";
    VestaFeeType["BorrowerElectedSurveyFee"] = "BorrowerElectedSurveyFee";
    VestaFeeType["RecordingFeeForAssignment"] = "RecordingFeeForAssignment";
    VestaFeeType["RecordingFeeForDeed"] = "RecordingFeeForDeed";
    VestaFeeType["RecordingFeeForMortgage"] = "RecordingFeeForMortgage";
    VestaFeeType["RecordingFeeForMunicipalLienCertificate"] = "RecordingFeeForMunicipalLienCertificate";
    VestaFeeType["RecordingFeeForOtherDocument"] = "RecordingFeeForOtherDocument";
    VestaFeeType["RecordingFeeForRelease"] = "RecordingFeeForRelease";
    VestaFeeType["RecordingFeeForSubordination"] = "RecordingFeeForSubordination";
    VestaFeeType["TaxStampForCityDeed"] = "TaxStampForCityDeed";
    VestaFeeType["TaxStampForCityMortgage"] = "TaxStampForCityMortgage";
    VestaFeeType["TaxStampForCountyDeed"] = "TaxStampForCountyDeed";
    VestaFeeType["TaxStampForCountyMortgage"] = "TaxStampForCountyMortgage";
    VestaFeeType["TaxStampForStateDeed"] = "TaxStampForStateDeed";
    VestaFeeType["TaxStampForStateMortgage"] = "TaxStampForStateMortgage";
    VestaFeeType["TransferTaxTotal"] = "TransferTaxTotal";
    VestaFeeType["PowerOfAttorneyRecordingFee"] = "PowerOfAttorneyRecordingFee";
    VestaFeeType["OtherRecordingFee"] = "OtherRecordingFee";
    VestaFeeType["OtherTransferTax"] = "OtherTransferTax";
    VestaFeeType["RecordingServiceFee"] = "RecordingServiceFee";
    VestaFeeType["GRMAFee"] = "GRMAFee";
    VestaFeeType["AppraisalFee"] = "AppraisalFee";
    VestaFeeType["AppraisalManagementCompanyFee"] = "AppraisalManagementCompanyFee";
    VestaFeeType["BankruptcyMonitoringFee"] = "BankruptcyMonitoringFee";
    VestaFeeType["CreditReportFee"] = "CreditReportFee";
    VestaFeeType["FloodCertification"] = "FloodCertification";
    VestaFeeType["FloodCertificationLifeOfLoan"] = "FloodCertificationLifeOfLoan";
    VestaFeeType["MERSRegistrationFee"] = "MERSRegistrationFee";
    VestaFeeType["PestInspectionFee"] = "PestInspectionFee";
    VestaFeeType["TitleRecordingServiceFee"] = "TitleRecordingServiceFee";
    VestaFeeType["ReinspectionFee"] = "ReinspectionFee";
    VestaFeeType["SurveyFee"] = "SurveyFee";
    VestaFeeType["TaxServiceFee"] = "TaxServiceFee";
    VestaFeeType["TaxStatusResearchFee"] = "TaxStatusResearchFee";
    VestaFeeType["TitleAbstractFee"] = "TitleAbstractFee";
    VestaFeeType["TitleBorrowerClosingProtectionLetterFee"] = "TitleBorrowerClosingProtectionLetterFee";
    VestaFeeType["TitleCertificationFee"] = "TitleCertificationFee";
    VestaFeeType["TitleClosingCoordinationFee"] = "TitleClosingCoordinationFee";
    VestaFeeType["TitleClosingFee"] = "TitleClosingFee";
    VestaFeeType["TitleClosingProtectionLetterFee"] = "TitleClosingProtectionLetterFee";
    VestaFeeType["TitleDocumentPreparationFee"] = "TitleDocumentPreparationFee";
    VestaFeeType["TitleEndorsementFee"] = "TitleEndorsementFee";
    VestaFeeType["TitleExaminationFee"] = "TitleExaminationFee";
    VestaFeeType["TitleFinalPolicyShortFormFee"] = "TitleFinalPolicyShortFormFee";
    VestaFeeType["TitleInsuranceBinderFee"] = "TitleInsuranceBinderFee";
    VestaFeeType["TitleInsuranceFee"] = "TitleInsuranceFee";
    VestaFeeType["TitleLendersCoveragePremium"] = "TitleLendersCoveragePremium";
    VestaFeeType["TitleNotaryFee"] = "TitleNotaryFee";
    VestaFeeType["TitleServicesSalesTax"] = "TitleServicesSalesTax";
    VestaFeeType["TitleUnderwritingIssueResolutionFee"] = "TitleUnderwritingIssueResolutionFee";
    VestaFeeType["USDARuralDevelopmentGuaranteeFee"] = "USDARuralDevelopmentGuaranteeFee";
    VestaFeeType["VAFundingFee"] = "VAFundingFee";
    VestaFeeType["VerificationOfAssetsFee"] = "VerificationOfAssetsFee";
    VestaFeeType["VerificationOfEmploymentFee"] = "VerificationOfEmploymentFee";
    VestaFeeType["VerificationOfIncomeFee"] = "VerificationOfIncomeFee";
    VestaFeeType["VerificationOfResidencyStatusFee"] = "VerificationOfResidencyStatusFee";
    VestaFeeType["VerificationOfTaxpayerIdentificationFee"] = "VerificationOfTaxpayerIdentificationFee";
    VestaFeeType["VerificationOfTaxReturnFee"] = "VerificationOfTaxReturnFee";
    VestaFeeType["TitleCopyOrFaxFee"] = "TitleCopyOrFaxFee";
    VestaFeeType["TitleElectronicDocumentDeliveryFee"] = "TitleElectronicDocumentDeliveryFee";
    VestaFeeType["TitleFilingFee"] = "TitleFilingFee";
    VestaFeeType["TitleCourierFee"] = "TitleCourierFee";
    VestaFeeType["EscrowServiceFee"] = "EscrowServiceFee";
    VestaFeeType["TitleAttorneyFee"] = "TitleAttorneyFee";
    VestaFeeType["TitleProcessingFee"] = "TitleProcessingFee";
    VestaFeeType["TitleWireTransferFee"] = "TitleWireTransferFee";
    VestaFeeType["TitleDeedPreparationFee"] = "TitleDeedPreparationFee";
    VestaFeeType["MunicipalLienCertificateFee"] = "MunicipalLienCertificateFee";
    VestaFeeType["TitleReconveyanceFee"] = "TitleReconveyanceFee";
    VestaFeeType["MIUpfrontPremium"] = "MIUpfrontPremium";
    VestaFeeType["AttorneyDocumentPreparationFee"] = "AttorneyDocumentPreparationFee";
    VestaFeeType["ERecordingFee"] = "ERecordingFee";
    VestaFeeType["PrepaidInterest"] = "PrepaidInterest";
    VestaFeeType["MIInitialPremium"] = "MIInitialPremium";
    VestaFeeType["TitleUpdate203K"] = "TitleUpdate203K";
    VestaFeeType["AppraisalFieldReviewFee"] = "AppraisalFieldReviewFee";
    VestaFeeType["AsbestosInspectionFee"] = "AsbestosInspectionFee";
    VestaFeeType["ElectronicDocumentDeliveryFee"] = "ElectronicDocumentDeliveryFee";
    VestaFeeType["HeatingCoolingInspectionFee"] = "HeatingCoolingInspectionFee";
    VestaFeeType["LeadInspectionFee"] = "LeadInspectionFee";
    VestaFeeType["MoldInspectionFee"] = "MoldInspectionFee";
    VestaFeeType["TitlePowerOfAttorneyPreparationFee"] = "TitlePowerOfAttorneyPreparationFee";
    VestaFeeType["RadonInspectionFee"] = "RadonInspectionFee";
    VestaFeeType["RoofInspectionFee"] = "RoofInspectionFee";
    VestaFeeType["TitleSettlementFee"] = "TitleSettlementFee";
    VestaFeeType["StateTitleInsuranceFee"] = "StateTitleInsuranceFee";
    VestaFeeType["StructuralInspectionFee"] = "StructuralInspectionFee";
    VestaFeeType["SepticInspectionFee"] = "SepticInspectionFee";
    VestaFeeType["Consultants203K"] = "Consultants203K";
    VestaFeeType["USDATechnologyFee"] = "USDATechnologyFee";
    VestaFeeType["TitleSubEscrowFee"] = "TitleSubEscrowFee";
})(VestaFeeType || (exports.VestaFeeType = VestaFeeType = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/ClosingAdjustmentCounterparty
var VestaClosingAdjustmentCounterParty;
(function (VestaClosingAdjustmentCounterParty) {
    VestaClosingAdjustmentCounterParty["Seller"] = "Seller";
    VestaClosingAdjustmentCounterParty["Lender"] = "Lender";
    VestaClosingAdjustmentCounterParty["Builder"] = "Builder";
    VestaClosingAdjustmentCounterParty["Broker"] = "Broker";
    VestaClosingAdjustmentCounterParty["RealEstateAgent"] = "RealEstateAgent";
    VestaClosingAdjustmentCounterParty["Correspondent"] = "Correspondent";
    VestaClosingAdjustmentCounterParty["Other"] = "Other";
    VestaClosingAdjustmentCounterParty["Employer"] = "Employer";
    VestaClosingAdjustmentCounterParty["BuilderDeveloper"] = "BuilderDeveloper";
    VestaClosingAdjustmentCounterParty["EmployerAffiliate"] = "EmployerAffiliate";
    VestaClosingAdjustmentCounterParty["LenderAffiliate"] = "LenderAffiliate";
    VestaClosingAdjustmentCounterParty["OtherInterestedParty"] = "OtherInterestedParty";
})(VestaClosingAdjustmentCounterParty || (exports.VestaClosingAdjustmentCounterParty = VestaClosingAdjustmentCounterParty = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/ObjectiveTaskStatus
var VestaObjectiveTaskStatus;
(function (VestaObjectiveTaskStatus) {
    VestaObjectiveTaskStatus["Ready"] = "Ready";
    VestaObjectiveTaskStatus["ManuallyCompleted"] = "ManuallyCompleted";
    VestaObjectiveTaskStatus["AutomaticallyCompleted"] = "AutomaticallyCompleted";
    VestaObjectiveTaskStatus["ManuallyCancelled"] = "ManuallyCancelled";
    VestaObjectiveTaskStatus["AutomaticallyCancelled"] = "AutomaticallyCancelled";
})(VestaObjectiveTaskStatus || (exports.VestaObjectiveTaskStatus = VestaObjectiveTaskStatus = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/ObjectiveTaskTemplateType
var VestaObjectiveTaskTemplateType;
(function (VestaObjectiveTaskTemplateType) {
    VestaObjectiveTaskTemplateType["DocumentProcessing"] = "DocumentProcessing";
    VestaObjectiveTaskTemplateType["DocumentRequired"] = "DocumentRequired";
    VestaObjectiveTaskTemplateType["FormInput"] = "FormInput";
    VestaObjectiveTaskTemplateType["Instructions"] = "Instructions";
    VestaObjectiveTaskTemplateType["ScenarioChange"] = "ScenarioChange";
    VestaObjectiveTaskTemplateType["DocumentDiscrepancies"] = "DocumentDiscrepancies";
    VestaObjectiveTaskTemplateType["ManualDocumentRequest"] = "ManualDocumentRequest";
    VestaObjectiveTaskTemplateType["SimpleCondition"] = "SimpleCondition";
})(VestaObjectiveTaskTemplateType || (exports.VestaObjectiveTaskTemplateType = VestaObjectiveTaskTemplateType = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/ObjectiveConditionStatus
var VestaObjectiveTaskConditionStatus;
(function (VestaObjectiveTaskConditionStatus) {
    VestaObjectiveTaskConditionStatus["NotReadyToApprove"] = "NotReadyToApprove";
    VestaObjectiveTaskConditionStatus["ReadyToApprove"] = "ReadyToApprove";
    VestaObjectiveTaskConditionStatus["Approved"] = "Approved";
    VestaObjectiveTaskConditionStatus["Cancelled"] = "Cancelled";
})(VestaObjectiveTaskConditionStatus || (exports.VestaObjectiveTaskConditionStatus = VestaObjectiveTaskConditionStatus = {}));
// We define these ourselves
// Order here is the order in Vesta
var VestaObjectiveTaskTemplateExternalIdentifier;
(function (VestaObjectiveTaskTemplateExternalIdentifier) {
    // Borrower needs list - upload
    VestaObjectiveTaskTemplateExternalIdentifier["uploadGovernmentIdentification"] = "uploadGovernmentIdentification";
    VestaObjectiveTaskTemplateExternalIdentifier["uploadMostRecentPaystub"] = "uploadMostRecentPaystub";
    VestaObjectiveTaskTemplateExternalIdentifier["upload2ndMostRecentPaystub"] = "upload2ndMostRecentPaystub";
    VestaObjectiveTaskTemplateExternalIdentifier["upload2022W2"] = "upload2022W2";
    VestaObjectiveTaskTemplateExternalIdentifier["upload2023W2"] = "upload2023W2";
    VestaObjectiveTaskTemplateExternalIdentifier["upload2024W2"] = "upload2024W2";
    VestaObjectiveTaskTemplateExternalIdentifier["upload2025W2"] = "upload2025W2";
    VestaObjectiveTaskTemplateExternalIdentifier["uploadMostRecentBankStatement"] = "uploadMostRecentBankStatement";
    VestaObjectiveTaskTemplateExternalIdentifier["upload2ndMostRecentBankStatement"] = "upload2ndMostRecentBankStatement";
    VestaObjectiveTaskTemplateExternalIdentifier["uploadInvestmentAccountStatement"] = "uploadInvestmentAccountStatement";
    VestaObjectiveTaskTemplateExternalIdentifier["uploadMostRecentInvestmentAccountStatement"] = "uploadMostRecentInvestmentAccountStatement";
    VestaObjectiveTaskTemplateExternalIdentifier["upload2ndMostRecentInvestmentAccountStatement"] = "upload2ndMostRecentInvestmentAccountStatement";
    VestaObjectiveTaskTemplateExternalIdentifier["uploadRetirementAccountStatement"] = "uploadRetirementAccountStatement";
    VestaObjectiveTaskTemplateExternalIdentifier["uploadMostRecentRetirementAccountStatement"] = "uploadMostRecentRetirementAccountStatement";
    VestaObjectiveTaskTemplateExternalIdentifier["upload2ndMostRecentRetirementAccountStatement"] = "upload2ndMostRecentRetirementAccountStatement";
    VestaObjectiveTaskTemplateExternalIdentifier["uploadRetirementTermsAndConditionsOfWithdrawal"] = "uploadRetirementTermsAndConditionsOfWithdrawal";
    VestaObjectiveTaskTemplateExternalIdentifier["uploadSourceOfFundsForLargeDeposit"] = "uploadSourceOfFundsForLargeDeposit";
    VestaObjectiveTaskTemplateExternalIdentifier["uploadMortgageStatement"] = "uploadMortgageStatement";
    VestaObjectiveTaskTemplateExternalIdentifier["uploadHomeownersInsuranceHoiPolicy"] = "uploadHomeownersInsuranceHoiPolicy";
    VestaObjectiveTaskTemplateExternalIdentifier["uploadHomeownersAssociationHoaStatement"] = "uploadHomeownersAssociationHoaStatement";
    VestaObjectiveTaskTemplateExternalIdentifier["uploadFloodInsurancePolicy"] = "uploadFloodInsurancePolicy";
    VestaObjectiveTaskTemplateExternalIdentifier["uploadHomeownersInsuranceHoiPolicyOwnedProperty"] = "uploadHomeownersInsuranceHoiPolicyOwnedProperty";
    VestaObjectiveTaskTemplateExternalIdentifier["uploadHomeownersAssociationHoaStatementOwnedProperty"] = "uploadHomeownersAssociationHoaStatementOwnedProperty";
    // Borrower needs list - generated doc
    // TODO(william.qin): implement generated doc tasks
    // uploadLetterOfExplanationForLargeDeposit = 'uploadLetterOfExplanationForLargeDeposit',
    VestaObjectiveTaskTemplateExternalIdentifier["uploadLetterOfExplanationForCreditInquiries"] = "uploadLetterOfExplanationForCreditInquiries";
})(VestaObjectiveTaskTemplateExternalIdentifier || (exports.VestaObjectiveTaskTemplateExternalIdentifier = VestaObjectiveTaskTemplateExternalIdentifier = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/ObjectiveStatus
var VestaObjectiveStatus;
(function (VestaObjectiveStatus) {
    VestaObjectiveStatus["NotStarted"] = "NotStarted";
    VestaObjectiveStatus["InProgress"] = "InProgress";
    VestaObjectiveStatus["Completed"] = "Completed";
    VestaObjectiveStatus["Escalated"] = "Escalated";
    VestaObjectiveStatus["Cancelled"] = "Cancelled";
    VestaObjectiveStatus["Upcoming"] = "Upcoming";
    VestaObjectiveStatus["Blocked"] = "Blocked";
})(VestaObjectiveStatus || (exports.VestaObjectiveStatus = VestaObjectiveStatus = {}));
// We define these ourselves - for now we are only concerned with one objective template
var VestaObjectiveTemplateExternalIdentifier;
(function (VestaObjectiveTemplateExternalIdentifier) {
    VestaObjectiveTemplateExternalIdentifier["borrowerNeedsList"] = "borrowerNeedsList";
})(VestaObjectiveTemplateExternalIdentifier || (exports.VestaObjectiveTemplateExternalIdentifier = VestaObjectiveTemplateExternalIdentifier = {}));
// https://aven.beta.vesta.com/api?version=_26_2#/schemas/DocumentStatus
var VestaDocumentStatus;
(function (VestaDocumentStatus) {
    VestaDocumentStatus["Uploaded"] = "Uploaded";
    VestaDocumentStatus["Reviewed"] = "Reviewed";
    VestaDocumentStatus["Accepted"] = "Accepted";
    VestaDocumentStatus["Archived"] = "Archived";
    VestaDocumentStatus["Expired"] = "Expired";
})(VestaDocumentStatus || (exports.VestaDocumentStatus = VestaDocumentStatus = {}));
